{
  "chart.area": "Område",
  "chart.bar": "Stolpe",
  "chart.pie": "Kake",
  "chart.radar": "Radar",
  "chartChooser.chooseChart": "Velg graf",
  "chartChooser.missingData": "Manglar data for graf.",
  "chartChooser.noSelect": "Ingen graf vald.",
  "chartChooser.unavailable": "Graftypen er utilgjengeleg",
  "numberOf": "Antal"
}
